import { gql } from '@apollo/client';

import { AD_TRAFFICKING_COLUMN } from '../../../../../../TraffickingPage/hooks/fragments/adFragments';
import { CREATE_ADS_WITH_CREATIVES_FAILED_AD_ENTITY_FIELDS } from './createAdsWithCreativesFailedAdEntityFields';

export const CREATE_ADS_WITH_CREATIVES_AD_ENTITY_FIELDS = gql`
  fragment CreateAdsWithCreativesAdEntityFields on CreateAdsWithCreativesAdEntity {
    ... on AdV5 {
      ...adTraffickingColumn
    }
    ... on CreateAdsWithCreativesFailedAdEntity {
      ...CreateAdsWithCreativesFailedAdEntityFields
    }
  }
  ${AD_TRAFFICKING_COLUMN}
  ${CREATE_ADS_WITH_CREATIVES_FAILED_AD_ENTITY_FIELDS}
`;
